import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { powerUnit } from '../../../../util/formatters'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function HeatingGroundHeatPumpForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatingGroundHeatPump.cop"
          rules={{
            ...validators.required,
            ...validators.cop,
          }}
          error={errors.parameters?.heatingGroundHeatPump?.cop}
          label={t('createProvider.forms.heatingGroundHeatPump.cop')}
          defaultValue="4"
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.heatingGroundHeatPump.maxPower"
          rules={{
            ...validators.required,
            ...validators.maxPower,
          }}
          error={errors.parameters?.heatingGroundHeatPump?.maxPower}
          label={t('createProvider.forms.heatingGroundHeatPump.maxPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>
    </>
  )
}
